import type { ReactNode } from "react";
import pharmacyPartnerTermsUrl from "../content/legal/pharmacy-partner-terms.pdf?url";
import { TERMS_AGREEMENT_LABEL } from "../lib/termsAgreement";

/**
 * URL of the committed Pharmacy Partner Terms PDF. It is a Vite `?url` asset,
 * so each SPA ships its own content-hashed copy under `/assets/` and the URL
 * is stable only within one build: it has no public address to persist or
 * send to the server.
 */
export const PHARMACY_PARTNER_TERMS_URL: string = pharmacyPartnerTermsUrl;

/** The words of `TERMS_AGREEMENT_LABEL` that carry the link. */
const LINK_TEXT = "Terms & Conditions";

interface TermsAgreementLabelProps {
  /** Link "Terms & Conditions" to the PDF; off, the sentence is plain text. */
  linked: boolean;
}

/**
 * Label of the Terms & Conditions checkbox, built from `TERMS_AGREEMENT_LABEL`
 * so its text content equals the server's acceptance intent in both modes.
 * Linked, "Terms & Conditions" opens the Pharmacy Partner Terms PDF in a new
 * tab; the anchor is interactive content inside the `<label>`, so activating it
 * does not toggle the checkbox. The document names a Pharmacy as its
 * counterparty, so a Broker org renders the plain sentence.
 */
export function TermsAgreementLabel({ linked }: TermsAgreementLabelProps): ReactNode {
  if (!linked) return TERMS_AGREEMENT_LABEL;
  const at = TERMS_AGREEMENT_LABEL.indexOf(LINK_TEXT);
  return (
    <>
      {TERMS_AGREEMENT_LABEL.slice(0, at)}
      <a
        href={PHARMACY_PARTNER_TERMS_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="text-primary-text hover:text-ember-dark underline"
      >
        {LINK_TEXT}
      </a>
      {TERMS_AGREEMENT_LABEL.slice(at + LINK_TEXT.length)}
    </>
  );
}
